module.exports = __webpack_public_path__ + "img/标题背景.63773bd7.png";